import React, {useState, useEffect} from "react";
import { useTable, useSortBy } from "react-table";

export const ReactTable = ({ columns, data, className }) => {
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    setTableData(tableData)
  }, [data])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    disablePageResetOnDataChange,
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  return (
    <>
      <table {...getTableProps()} className={`default-table ${className ? className : ''}`}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}

                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
          
        <tbody 
          {...getTableBodyProps()}
        >
          {rows.map(row => {
            prepareRow(row);

            return (
              <tr 
                {...row.getRowProps()}
                className={row.original.newItem ? 'newItem' : ''}
              >

                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps({
                        className: cell.column.className
                      })}
                    >
                      {cell.render("Cell")}
                    </td>
                  )})}
              </tr>

            )})}
        </tbody>
      </table>
      <br />
    </>
  );
};